export default {
	state: {
		epoListingSearchForm: sessionStorage.epoListingSearchForm ? JSON.parse(sessionStorage.epoListingSearchForm) : null,
		inboundSearchForm: sessionStorage.inboundSearchForm ? JSON.parse(sessionStorage.inboundSearchForm) : null,
		manifestConsignmentSearchForm: sessionStorage.manifestConsignmentSearchForm ? JSON.parse(sessionStorage.manifestConsignmentSearchForm) : null,
		orderReceiveSearchForm: sessionStorage.orderReceiveSearchForm ? JSON.parse(sessionStorage.orderReceiveSearchForm) : null,
		courierStatusInquirySearchForm: sessionStorage.courierStatusInquirySearchForm ? JSON.parse(sessionStorage.courierStatusInquirySearchForm) : null,
		consignmentSoSearchForm: sessionStorage.consignmentSoSearchForm ? JSON.parse(sessionStorage.consignmentSoSearchForm) : null,
		packingTypeSearchForm: sessionStorage.packingTypeSearchForm ? JSON.parse(sessionStorage.packingTypeSearchForm) : null,
		transitOrderSearchForm: sessionStorage.transitOrderSearchForm ? JSON.parse(sessionStorage.transitOrderSearchForm) : null,
		wttSearchForm: sessionStorage.wttSearchForm ? JSON.parse(sessionStorage.wttSearchForm) : null,
		norSearchForm: sessionStorage.norSearchForm ? JSON.parse(sessionStorage.norSearchForm) : null,
		loadingSearchForm: sessionStorage.loadingSearchForm ? JSON.parse(sessionStorage.loadingSearchForm) : null,
		packingListSearchForm: sessionStorage.packingListSearchForm ? JSON.parse(sessionStorage.packingListSearchForm) : null,
		orderReceivingSummarySearchForm: sessionStorage.orderReceivingSummarySearchForm ? JSON.parse(sessionStorage.orderReceivingSummarySearchForm) : null,
		maintainTTDepositSearchForm: sessionStorage.maintainTTDepositSummarySearchForm ? JSON.parse(sessionStorage.maintainTTDepositSummarySearchForm) : null,
		packingListByMsmSearchForm: sessionStorage.packingListByMsmSearchForm ? JSON.parse(sessionStorage.packingListByMsmSearchForm) : null,
		reopenCloseLoadingForm: sessionStorage.reopenCloseLoadingForm ? JSON.parse(sessionStorage.reopenCloseLoadingForm) : null,
		stockBalWithPaymentInfoSearchForm: sessionStorage.stockBalWithPaymentInfoSearchForm ? JSON.parse(sessionStorage.stockBalWithPaymentInfoSearchForm) : null,
		gimWorldOrderSearchForm: sessionStorage.gimWorldOrderSearchForm ? JSON.parse(sessionStorage.gimWorldOrderSearchForm) : null,
		postGimWorldOrderSearchForm: sessionStorage.postGimWorldOrderSearchForm ? JSON.parse(sessionStorage.postGimWorldOrderSearchForm) : null,
		reopenSoSearchForm: sessionStorage.reopenSoSearchForm ? JSON.parse(sessionStorage.reopenSoSearchForm) : null,
		closeReopenSoSearchForm: sessionStorage.closeReopenSoSearchForm ? JSON.parse(sessionStorage.closeReopenSoSearchForm) : null,
		refIdSummarSearchForm: sessionStorage.refIdSummarSearchForm ? JSON.parse(sessionStorage.refIdSummarSearchForm) : null,
		reopenLoadingSearchForm: sessionStorage.reopenLoadingSearchForm ? JSON.parse(sessionStorage.reopenLoadingSearchForm) : null,
		closeLoadingSearchForm: sessionStorage.closeLoadingSearchForm ? JSON.parse(sessionStorage.closeLoadingSearchForm) : null,
		inquiryReopenSoForm: sessionStorage.inquiryReopenSoForm ? JSON.parse(sessionStorage.inquiryReopenSoForm) : null,
		loadingContainerSearchForm: sessionStorage.loadingContainerSearchForm ? JSON.parse(sessionStorage.loadingContainerSearchForm) : null,
		inquiryReopenLoadingForm: sessionStorage.inquiryReopenLoadingForm ? JSON.parse(sessionStorage.inquiryReopenLoadingForm) : null,
		paymentHistoryForm: sessionStorage.paymentHistoryForm ? JSON.parse(sessionStorage.paymentHistoryForm) : null,
		closeOrderPaymentForm: sessionStorage.closeOrderPaymentForm ? JSON.parse(sessionStorage.closeOrderPaymentForm) : null,
		deliveryAddressSearchForm: sessionStorage.deliveryAddressSearchForm ? JSON.parse(sessionStorage.deliveryAddressSearchForm) : null
	},
	getters: {},
	actions: {
		setEpoListingSearchForm(state, payload) {
			state.commit("setEpoListingSearchForm", payload);
		},
		setInboundSearchForm(state, payload) {
			state.commit("setInboundSearchForm", payload);
		},
		setManifestConsignmentSearchForm(state, payload) {
			state.commit("setManifestConsignmentSearchForm", payload);
		},
		setOrderRcvSummarySearchForm(state, payload) {
			state.commit("setOrderRcvSummarySearchForm", payload);
		},
		setOrderReceiveSearchForm(state, payload) {
			state.commit("setOrderReceiveSearchForm", payload);
		},
		setCourierStatusInquirySearchForm(state, payload) {
			state.commit("setCourierStatusInquirySearchForm", payload);
		},
		setConsignmentSoSearchForm(state, payload) {
			state.commit("setConsignmentSoSearchForm", payload);
		},
		setPackingTypeSearchForm(state, payload) {
			state.commit("setPackingTypeSearchForm", payload);
		},
		setTransitOrderSearchForm(state, payload) {
			state.commit("setTransitOrderSearchForm", payload);
		},
		setWttSearchForm(state, payload) {
			state.commit("setWttSearchForm", payload);
		},
		setNorSearchForm(state, payload) {
			state.commit("setNorSearchForm", payload);
		},
		setLoadingSearchForm(state, payload) {
			state.commit("setLoadingSearchForm", payload);
		},
		setPackingListSearchForm(state, payload) {
			state.commit("setPackingListSearchForm", payload);
		},
		setOrderReceivingSummarySearchForm(state, payload) {
			state.commit("setOrderReceivingSummarySearchForm", payload);
		},
		setMaintainTTDepositSummarySearchForm(state, payload) {
			state.commit("setMaintainTTDepositSummarySearchForm", payload);
		},
		setPackingListByMsmSearchForm(state, payload) {
			state.commit("setPackingListByMsmSearchForm", payload);
		},
		setReopenCloseLoadingForm(state, payload) {
			state.commit("setReopenCloseLoadingForm", payload);
		},
		setstockBalWithPaymentInfoSearchForm(state, payload) {
			state.commit("setstockBalWithPaymentInfoSearchForm", payload);
		},
		setGimWorldOrderSearchForm(state, payload) {
			state.commit("setGimWorldOrderSearchForm", payload);
		},
		setPostGimWorldOrderSearchForm(state, payload) {
			state.commit("setPostGimWorldOrderSearchForm", payload);
		},
		setReopenSoSearchForm(state, payload) {
			state.commit("setReopenSoSearchForm", payload);
		},
		setCloseReopenSoSearchForm(state, payload) {
			state.commit("setCloseReopenSoSearchForm", payload);
		},
		setRefIdSummarSearchForm(state, payload) {
			state.commit("setRefIdSummarSearchForm", payload);
		},
		setReopenLoadingSearchForm(state, payload) {
			state.commit("setReopenLoadingSearchForm", payload);
		},
		setCloseLoadingSearchForm(state, payload) {
			state.commit("setCloseLoadingSearchForm", payload);
		},
		setInquiryReopenSoForm(state, payload) {
			state.commit("setInquiryReopenSoForm", payload);
		},
		setLoadingContainerSearchForm(state, payload) {
			state.commit("setLoadingContainerSearchForm", payload);
		},
		setInquiryReopenLoadingForm(state, payload) {
			state.commit("setInquiryReopenLoadingForm", payload)
		},
		setPaymentHistoryForm(state, payload) {
			state.commit("setPaymentHistoryForm", payload);
		},
		setCloseOrderRcvForm(state, payload) {
			state.commit("setCloseOrderRcvForm", payload);
		},
		setDeliveryAddressSearchForm(state, payload) {
			state.commit("setDeliveryAddressSearchForm", payload)
		}
	},
	mutations: {
		setEpoListingSearchForm(state, payload) {
			state.epoListingSearchForm = payload;
			sessionStorage.epoListingSearchForm = JSON.stringify(payload); // fixed!
		},
		setInboundSearchForm(state, payload) {
			state.inboundSearchForm = payload;
			sessionStorage.inboundSearchForm = JSON.stringify(payload); // fixed!
		},
		setManifestConsignmentSearchForm(state, payload) {
			state.manifestConsignmentSearchForm = payload;
			sessionStorage.manifestConsignmentSearchForm = JSON.stringify(payload); // fixed!
		},
		setOrderReceiveSearchForm(state, payload) {
			state.orderReceiveSearchForm = payload;
			sessionStorage.orderReceiveSearchForm = JSON.stringify(payload); // fixed!
		},

		setOrderRcvSummarySearchForm(state, payload) {
			state.OrderRcvSummarySearchForm = payload;
			sessionStorage.OrderRcvSummarySearchForm = JSON.stringify(payload); // fixed!
		},
		setCourierStatusInquirySearchForm(state, payload) {
			state.courierStatusInquirySearchForm = payload;
			sessionStorage.courierStatusInquirySearchForm = JSON.stringify(payload); // fixed!
		},
		setConsignmentSoSearchForm(state, payload) {
			state.consignmentSoSearchForm = payload;
			sessionStorage.consignmentSoSearchForm = JSON.stringify(payload);
		},
		setPackingTypeSearchForm(state, payload) {
			state.packingTypeSearchForm = payload;
			sessionStorage.packingTypeSearchForm = JSON.stringify(payload);
		},
		setTransitOrderSearchForm(state, payload) {
			state.transitOrderSearchForm = payload;
			sessionStorage.transitOrderSearchForm = JSON.stringify(payload);
		},
		setWttSearchForm(state, payload) {
			state.wttSearchForm = payload;
			sessionStorage.wttSearchForm = JSON.stringify(payload);
		},
		setNorSearchForm(state, payload) {
			state.norSearchForm = payload;
			sessionStorage.norSearchForm = JSON.stringify(payload);
		},
		setLoadingSearchForm(state, payload) {
			state.loadingSearchForm = payload;
			sessionStorage.loadingSearchForm = JSON.stringify(payload);
		},
		setPackingListSearchForm(state, payload) {
			state.packingListSearchForm = payload;
			sessionStorage.packingListSearchForm = JSON.stringify(payload);
		},
		setOrderReceivingSummarySearchForm(state, payload) {
			state.orderReceivingSummarySearchForm = payload;
			sessionStorage.orderReceivingSummarySearchForm = JSON.stringify(payload);
		},
		setMaintainTTDepositSummarySearchForm(state, payload) {
			state.maintainTTDepositSummarySearchForm = payload;
			sessionStorage.maintainTTDepositSummarySearchForm = JSON.stringify(payload);
		},
		setPackingListByMsmSearchForm(state, payload) {
			state.packingListByMsmSearchForm = payload;
			sessionStorage.packingListByMsmSearchForm = JSON.stringify(payload);
		},
		setReopenCloseLoadingForm(state, payload) {
			state.reopenCloseLoadingForm = payload;
			sessionStorage.reopenCloseLoadingForm = JSON.stringify(payload);
		},
		setLoadingContainerSearchForm(state, payload) {
			state.loadingContainerSearchForm = payload;
			sessionStorage.loadingContainerSearchForm = JSON.stringify(payload);
		},
		setstockBalWithPaymentInfoSearchForm(state, payload) {
			state.stockBalWithPaymentInfoSearchForm = payload;
			sessionStorage.stockBalWithPaymentInfoSearchForm = JSON.stringify(payload);
		},
		setGimWorldOrderSearchForm(state, payload) {
			state.gimWorldOrderSearchForm = payload;
			sessionStorage.gimWorldOrderSearchForm = JSON.stringify(payload);
		},
		setPostGimWorldOrderSearchForm(state, payload) {
			state.postGimWorldOrderSearchForm = payload;
			sessionStorage.postGimWorldOrderSearchForm = JSON.stringify(payload);
		},
		setReopenSoSearchForm(state, payload) {
			state.reopenSoSearchForm = payload;
			sessionStorage.reopenSoSearchForm = JSON.stringify(payload);
		},
		setCloseReopenSoSearchForm(state, payload) {
			state.closeReopenSoSearchForm = payload;
			sessionStorage.closeReopenSoSearchForm = JSON.stringify(payload);
		},
		setRefIdSummarSearchForm(state, payload) {
			state.refIdSummarSearchForm = payload;
			sessionStorage.refIdSummarSearchForm = JSON.stringify(payload);
		},
		setReopenLoadingSearchForm(state, payload) {
			state.reopenLoadingSearchForm = payload;
			sessionStorage.reopenLoadingSearchForm = JSON.stringify(payload);
		},
		setCloseLoadingSearchForm(state, payload) {
			state.closeLoadingSearchForm = payload;
			sessionStorage.closeLoadingSearchForm = JSON.stringify(payload);
		},
		setInquiryReopenSoForm(state, payload) {
			state.inquiryReopenSoForm = payload;
			sessionStorage.inquiryReopenSoForm = JSON.stringify(payload);
		},
		setInquiryReopenLoadingForm(state, payload) {
			state.inquiryReopenLoadingForm = payload;
			sessionStorage.inquiryReopenLoadingForm = JSON.stringify(payload);
		},
		setPaymentHistoryForm(state, payload) {
			state.paymentHistoryForm = payload;
			sessionStorage.paymentHistoryForm = JSON.stringify(payload);
		},
		setCloseOrderRcvForm(state, payload) {
			state.closeOrderPaymentForm = payload;
			sessionStorage.closeOrderPaymentForm = JSON.stringify(payload);
		},
		setDeliveryAddressSearchForm(state, payload) {
			state.deliveryAddressSearchForm = payload;
			sessionStorage.deliveryAddressSearchForm = JSON.stringify(payload)
		}
	}
};
